import { useState } from "react";

const useInput = (initialValue) => {
    const [value, setValue] = useState(initialValue);

    return {
        value,
        setValue,
        reset: () => setValue(""),
        bind: {
            value,
            onChange: (event) => {
                setValue(event.currentTarget.value);
            }
        }
    };
};

const useCheckbox = (initialValue) => {
    const [value, setValue] = useState(initialValue)

    return {
        value,
        setValue,
        reset: () => setValue(false),
        bind: {
            checked: value,
            onChange: (event) => {
                setValue(event.currentTarget.checked);
            }
        }
    };
}

const useFileInput = (initialValue) => {
    const [file, setFile] = useState(initialValue)

    return {
        file,
        setFile,
        reset: () => setFile(null),
        bind: {
            onChange: (event) => {
                setFile(event.currentTarget.files[0]);
            }
        }
    };
}

export { useInput, useCheckbox, useFileInput }